import ButtonAction from '../../../../../components/buttons/ButtonAction';
import SearchSimple from '../../../../../components/SearchSimples/SearchSimple';
import React from 'react';
import {permissionObj} from '../../../../../Helpers/permission';
import {VISITOR_SUB_VIEW_MODEL} from "../Model/Model";


/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 */
const InvitationMainHeader = (props) => {
    const {
        subView,
        handleSubViewChange,
        searchId,
        setBodyForExport,
        setSearchResults,
        searchElement,
        setSearchElement,
        option,
        page,
        rowsPerPage,
        setSimpleSearch,
        search,
        setSearch,
        setFinalArray, permission,
        DEV,
        userId,
        viewType
    } = props;

    return(<div className='d-flex'>
        <div className='d-flex'>
            {(DEV || permission?.includes(permissionObj?.WEB_VISITOR_INVITATION_READ)) &&
                <ButtonAction
                    id='btn_imh_ongoing'
                    name='ongoing'
                    className={VISITOR_SUB_VIEW_MODEL.INVITATION.ONGOING === subView ? 'btn-outlined-secondary-600-100 mr-8px' : 'btn-outlined-secondary-600-00 mr-8px'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        handleSubViewChange(VISITOR_SUB_VIEW_MODEL.INVITATION.ONGOING)
                    }}
                />
            }

            {(DEV || permission?.includes(permissionObj?.WEB_VISITOR_INVITATION_READ)) &&
                <ButtonAction
                    id='btn_imh_incoming'
                    name='incoming'
                    className={VISITOR_SUB_VIEW_MODEL.INVITATION.INCOMING === subView ? 'btn-outlined-secondary-600-100 mr-8px' : 'btn-outlined-secondary-600-00 mr-8px'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        handleSubViewChange(VISITOR_SUB_VIEW_MODEL.INVITATION.INCOMING)
                    }}
                />
            }

        </div>
        <div className='w-100'>
            <SearchSimple
                id={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                setFinalArray={setFinalArray} //Use for clean all filters in advanced search
                contractorId={userId}
                supplierId={null}
                viewType={viewType}
            />
        </div>
    </div>)
}

export default InvitationMainHeader;
